import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { List } from 'immutable';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import EditorHeaderContainer from '../EditorHeaderContainer';
import EditorAddContainer from '../EditorAddContainer';
import BlockContainer from '../BlockContainer';
import GlobalCounter from '../GlobalCounter';

import Paper from '../../components/ui/Paper';
import Wrapper from './Wrapper';
import Footer from './Footer';

import {
  selectEditorBlocks,
  selectEditorReadOnly,
  selectForceUpdateTextBlocks,
} from './selectors';

import {
  createBlock,
  setForceUpdateTextBlocks,
} from './actions';

export class EditorContainer extends React.PureComponent {
  static childContextTypes = {
    createBlock: PropTypes.func,
  };

  // TODO: убрать старый контекст
  getChildContext() {
    return {
      createBlock: this.props.createBlock,
    };
  }

  componentDidMount() {
    this.props.createBlock('TEXT', 0);
    this.focusOnNewInput();
  }

  componentDidUpdate(prevProps) {
    this.focusOnNewInput();

    if (this.props.forceUpdateTextBlocks && !prevProps.forceUpdateTextBlocks) {
      setTimeout(() => this.props.setForceUpdateTextBlocks(false), 0);
    }
  }

  handleAddNewInput = (inputRef) => {
    this.newInput = inputRef;
  }

  focusOnNewInput = () => {
    if (this.newInput) {
      this.newInput.focus();
      delete this.newInput;
    }
  }

  render() {
    return (
      <Wrapper>
        <Paper>
          <EditorHeaderContainer readOnly={this.props.readOnly} />

          <EditorAddContainer readOnly={this.props.readOnly} index={0} />

          {this.props.data.map((block, index) => (
            <BlockContainer
              key={block.get('key')}
              block={block}
              index={index}
              postType={this.props.postType}
              onAddNewInput={this.handleAddNewInput}
            />
          ))}

          <Footer>
            <GlobalCounter />
          </Footer>
        </Paper>
      </Wrapper>
    );
  }
}

EditorContainer.propTypes = {
  data: PropTypes.instanceOf(List),
  readOnly: PropTypes.bool,
  forceUpdateTextBlocks: PropTypes.bool,

  createBlock: PropTypes.func,
  setForceUpdateTextBlocks: PropTypes.func,

  postType: PropTypes.oneOf(['short', 'longread']),
};

EditorContainer.defaultProps = {
  data: List(),

  postType: undefined,
};

const mapStateToProps = createStructuredSelector({
  data: selectEditorBlocks(),
  readOnly: selectEditorReadOnly(),
  forceUpdateTextBlocks: selectForceUpdateTextBlocks(),
});

export function mapDispatchToProps(dispatch) {
  return {
    createBlock: (type, index, blockObject) => {
      dispatch(createBlock(type, index, blockObject));
    },
    setForceUpdateTextBlocks: (value) => {
      dispatch(setForceUpdateTextBlocks(value));
    },
  };
}

export default DragDropContext(HTML5Backend)(
  connect(mapStateToProps, mapDispatchToProps)(EditorContainer)
);
